import { render, staticRenderFns } from "./bindxzrmb.vue?vue&type=template&id=6916039a&scoped=true"
import script from "./bindxzrmb.vue?vue&type=script&lang=js"
export * from "./bindxzrmb.vue?vue&type=script&lang=js"
import style0 from "./bindxzrmb.vue?vue&type=style&index=0&id=6916039a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6916039a",
  null
  
)

export default component.exports